import(/* webpackMode: "eager" */ "/vercel/path0/web/web/src/app/tools/voice-tone-analyzer/page.tsx");
